import axios from 'axios';
import { Cookies } from 'react-cookie';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'x-initiator': 'call-center',
  },
});

axiosInstance.interceptors.request.use((config) => {
  const cookie = new Cookies();
  const accessToken = cookie.get('access_token');
  const language = localStorage.getItem('language') || 'uz';

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  config.headers['Accept-Language'] = language;

  return config;
});

// 401 da avtomatik logout qilmaslik kerak bo'lgan endpointlar (jim ishlovchi yon-so'rovlar)
const SILENT_AUTH_ENDPOINTS = ['/v1/notifications/update_token/'];

const shouldSilent = (config) => {
  const url = config?.url || '';
  return SILENT_AUTH_ENDPOINTS.some((endpoint) => url.includes(endpoint));
};

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const onLoginPage = window.location.pathname.includes('/login');

    if (status === 401 && !onLoginPage && !shouldSilent(error.config)) {
      const cookie = new Cookies();
      cookie.remove('access_token', { path: '/' });
      cookie.remove('refresh_token', { path: '/' });
      cookie.remove('role', { path: '/' });
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const apiClient = {
  get: (url, config) => axiosInstance.get(url, config),
  post: (url, data, config) => axiosInstance.post(url, data, config),
  put: (url, data, config) => axiosInstance.put(url, data, config),
  patch: (url, data, config) => axiosInstance.patch(url, data, config),
  del: (url, config) => axiosInstance.delete(url, config),
};

export const extractApiError = (error) =>
  error.response?.data?.detail ||
  error.response?.data?.message ||
  (typeof error.response?.data === 'string' ? error.response.data : null) ||
  error.message ||
  'Xatolik yuz berdi';

export default axiosInstance;
